/**
 * A search box: a text field with a magnifier in front.
 *
 * Controlled, and it does no searching — the page owns the term and debounces
 * it (`hooks/useDebounced`) before it becomes a request. One component so every
 * search box on every screen looks and behaves the same.
 */
import type { SxProps, Theme } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';

export interface SearchFieldProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  autoFocus?: boolean;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  sx?: SxProps<Theme>;
}

export function SearchField({
  value,
  onChange,
  placeholder,
  autoFocus = false,
  size = 'small',
  fullWidth = false,
  sx,
}: SearchFieldProps) {
  return (
    <TextField
      type="search"
      value={value}
      onChange={(event) => onChange(event.target.value)}
      {...(placeholder ? { placeholder } : {})}
      autoFocus={autoFocus}
      size={size}
      fullWidth={fullWidth}
      {...(sx ? { sx } : {})}
      slotProps={{
        input: { startAdornment: <SearchIcon fontSize="small" sx={{ mr: 1, color: 'text.secondary' }} /> },
      }}
    />
  );
}
